export function computeLinePrice(pricing, opts, pages) {
  if (!pricing) return 0;
  const size = (opts.size || "A4").toLowerCase();
  const colorKey = opts.color === "color" ? "color" : "bw";
  const unit = Number(pricing[`price_${size}_${opts.paper}_${colorKey}`] ?? 0.1);
  const mult = opts.sided === "double" ? Number(pricing.double_sided_multiplier ?? 1.8) : 1;
  const p = Math.max(1, pages || 1);
  const copies = Math.max(1, Number(opts.copies) || 1);
  return Math.round(unit * mult * copies * p * 100) / 100;
}

export const DEFAULT_DOC_OPTS = { copies: 1, color: "bw", size: "A4", paper: "80", sided: "single" };
